import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

import { MatSnackBar } from '@angular/material/snack-bar';

import { environment } from 'src/environments/environment';
import Resources from '../constants/resources';
import userFacingString from '../constants/userFacingStrings';
import Utils from '../constants/utils';

import { RestapiService } from './restapi.service';
import { SessionStorageService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  configuration: any = {};
  email: string;
  subscriptions: Subscription[] = [];
  acquisitionId: string;

  constructor(
    private http: HttpClient,
    private restAPI: RestapiService,
    private snackbar: MatSnackBar,
    private sessionService: SessionStorageService
  ) {
    this.acquisitionId = this.sessionService.getItemFromMemory(Resources.envKey.brokers) || environment.client;
  }

  // Load Confiration
  loadConfig() {
    return this.http.get(environment.api_url + `ui-configuration?acquisitionParty=${(this.acquisitionId).toUpperCase()}`)
      .toPromise().then((config) => {
        this.configuration = config;

        // Email Checking
        if (this.sessionService.getItemFromMemory(Resources.SessionStorageKeys.Email)) {
          this.email = this.sessionService.getItemFromMemory(Resources.SessionStorageKeys.Email);
          // is user loggedIn
          if (this.sessionService.getItemFromMemory(Resources.SessionStorageKeys.IsLoggedInUser)) {
            // Acquisition party
            if (!this.sessionService.getItemFromMemory(Resources.envKey.brokers)) {
              // Get company api
              this.getCustomerSummary();
            }
          }
        }
      })
      .catch((err) => {
        console.log('Config Error: ', err);
      })
  }

  // Get customer summary API to get acquistion party
  getCustomerSummary(): void {
    let cPath = 'customers/' + encodeURI(this.email) + '/companies?limit=10&offset=0';
    this.subscriptions.push(
      this.restAPI.getAPI(cPath).subscribe((data) => {
        // Store acquisition party id into session
        this.sessionService.setItemIntoMemory(Resources.envKey.brokers, data?.acqPartyId);
      }, err => {
        if (!!err?.error?.message) {
          Utils.showSnackBar(this.snackbar, err.error.message || userFacingString.Strings.errorMessage, 5000);
        } else {
          Utils.showSnackBar(this.snackbar, err.error.description || userFacingString.Strings.errorMessage, 5000);
        }
      })
    )
  }
}
